module.exports = __webpack_public_path__ + "static/img/d-business.97654aee.png";